import { inject, signal } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
} from "@angular/forms";

export abstract class FormHandlerBase {
  //for forms
  isSubmit = signal<boolean>(false);
  form!: FormGroup;
  formBuilder = inject(FormBuilder);

  // load form controls
  loadForm(controls: object): void {
    this.form = this.formBuilder.group(controls);
    this.form.markAsPristine();
  }

  formControlData(formControl: string): FormControl {
    return this.form.get(formControl) as FormControl;
  }

  get formControls() {
    return this.form.controls;
  }

  /**
   * Marks all form controls as touched and triggers validation.
   * This method also calls updateValueAndValidity on each control
   * to ensure OnPush components detect the changes.
   */
  markFormAsTouched(): void {
    this.form.markAllAsTouched();
    this.updateAllControls(this.form);
  }

  /**
   * Recursively updates all controls in the form group
   * to trigger change detection in OnPush components.
   */
  private updateAllControls(control: AbstractControl): void {
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach((key) => {
        this.updateAllControls(control.controls[key]);
      });
    }
    control.updateValueAndValidity({ emitEvent: true });
  }
}
